export const ru = {
    'iframe-title': 'Плеер Яндекс.Эфир',
};
